import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import Spinner from '@mos-front-components/public/es/components/Spinner';

import { getUserData } from '../../store/mainData/actions';
import {
  loadDraft,
  deleteDraft,
  loadDraftEmpty
} from '../../store/draft/actions';
import { userChangedModalOpen } from '../../store/userChangedModal/actions';

import {
  getUserSnilsSelector,
  mainDataValuesSelector
} from '../../store/mainData/selectors';
import {
  draftDataSelector,
  draftDateSelector,
  draftLoadingSelector,
  draftErrorSelector,
  draftLoadedVersionDateSelector,
  draftDeletedSelector
} from '../../store/draft/selectors';

import './FormPage.pcss';

import Confirmation from '../Confirmation/Confirmation';
import NotCorrectExam from '../NotCorrectExam/NotCorrectExam';
import RequestError from '../RequestError/RequestError';
import Form from '../Form/Form';
import Lead from '../../components/Lead/Lead';
import DraftChangeStatus from '../../components/DraftChangeStatus/DraftChangeStatus';
import DraftLoadedInfo from '../../components/DraftLoadedInfo/DraftLoadedInfo';
import DraftNotLoaded from '../../components/DraftNotLoaded/DraftNotLoaded';
import UserChangedModal from '../../containers/UserChangedModal/UserChangedModal';

import ACSBroadcast from '../../helpers/ACSBroadcast';
import { sendCMAAppealBusinessError } from '../../helpers/CMAStats';

class FormPage extends PureComponent {
  componentDidMount() {
    const { loadDraft, draftError } = this.props;

    ACSBroadcast.subscribe(this.onACSMessage);
    ACSBroadcast.init();

    if (draftError === null) {
      loadDraft();
    }
  }

  componentWillUnmount() {
    ACSBroadcast.off();
  }

  onACSMessage = message => {
    const { mainData, snils, getUserData, userChangedModalOpen } = this.props;
    const { type, profile } = message;
    const normSnils = input => input.replace(/[^\d]/g, '');

    switch (type) {
      case 'LOGOUT':
      case 'EXITING':
      case 'USER_UNAUTHORIZED':
        userChangedModalOpen();
        break;
      case 'PROFILE_UPDATED':
        if (profile && profile.person_type !== 'individual') {
          sendCMAAppealBusinessError({ stage: 'start' });
        }

        if (snils) {
          if (normSnils(snils) !== normSnils(profile.snils)) {
            userChangedModalOpen();
            return;
          }
        } else if (isEmpty(mainData)) {
          getUserData(profile);
        }

        break;
      default:
        break;
    }
  };

  onUserChangedModalClose = () => {
    window.location.reload();
  };

  render() {
    const {
      draftLoadedVersionDate,
      draftData,
      draftError,
      draftLoading,
      draftDeleted,
      draftDate,
      loadDraft,
      deleteDraft,
      loadDraftEmpty
    } = this.props;

    const isSpinner =
      draftData === null &&
      (draftError === null || draftError === true) &&
      draftLoading;
    const isDraftNotLoaded = !draftLoading && draftData === null;

    const showSpinner = () => {
      return (
        <div className="DraftSpinnerContainer">
          <Spinner />
        </div>
      );
    };

    const showDraftNotLoaded = () => {
      return (
        <DraftNotLoaded
          handleLoadDraft={loadDraft}
          handleDeleteDraft={deleteDraft}
          loadDraftEmpty={loadDraftEmpty}
        />
      );
    };

    return (
      <div className="FormPage">
        {draftLoadedVersionDate ? (
          <DraftLoadedInfo
            draftLoadedVersionDate={draftLoadedVersionDate}
            handleDeleteDraft={deleteDraft}
            loadDraftEmpty={loadDraftEmpty}
            draftDeleted={draftDeleted}
            draftLoading={draftLoading}
            draftError={draftError}
          />
        ) : null}
        <Lead />
        {isSpinner && showSpinner()}
        {!isSpinner && isDraftNotLoaded && showDraftNotLoaded()}
        {!isSpinner && !isDraftNotLoaded && <Form />}

        <Confirmation />
        <NotCorrectExam />
        <RequestError />
        {!draftLoading && draftData !== null && (
          <DraftChangeStatus
            draftDate={draftDate}
            draftLoading={draftLoading}
            draftError={draftError}
          />
        )}
        <UserChangedModal onCloseModal={this.onUserChangedModalClose} />
      </div>
    );
  }
}

FormPage.defaultProps = {
  mainData: null,
  snils: '',
  draftData: null,
  draftDate: null,
  draftLoading: false,
  draftError: false,
  draftDeleted: false,
  draftLoadedVersionDate: null
};

FormPage.propTypes = {
  getUserData: PropTypes.func.isRequired,
  mainData: PropTypes.shape({}),
  snils: PropTypes.string,
  draftData: PropTypes.object,
  draftDate: PropTypes.number,
  draftLoading: PropTypes.bool,
  draftError: PropTypes.bool,
  draftDeleted: PropTypes.bool,
  draftLoadedVersionDate: PropTypes.number
};

const mapStateToProps = state => ({
  mainData: mainDataValuesSelector(state),
  snils: getUserSnilsSelector(state),
  draftData: draftDataSelector(state),
  draftDate: draftDateSelector(state),
  draftLoading: draftLoadingSelector(state),
  draftError: draftErrorSelector(state),
  draftDeleted: draftDeletedSelector(state),
  draftLoadedVersionDate: draftLoadedVersionDateSelector(state)
});

const HomePageWrapper = connect(mapStateToProps, dispatch =>
  bindActionCreators(
    {
      getUserData,
      loadDraft,
      deleteDraft,
      loadDraftEmpty,
      userChangedModalOpen
    },
    dispatch
  )
)(FormPage);

export default HomePageWrapper;
